import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { baseQueryParams } from 'src/utils';

export const getOutageNumberLink = (props: {
  outageNumberLink?: LinkFieldValue;
  outageNumber?: string;
}) => {
  const { outageNumberLink, outageNumber } = props;

  if (!outageNumberLink?.href || !outageNumber) return undefined;

  const baseUrl = window.location.origin || '';
  const params = new URLSearchParams();
  params.set(baseQueryParams.reference, outageNumber);

  const path = outageNumberLink?.href;
  const queryString = params.toString();

  return {
    ...outageNumberLink,
    href: `${baseUrl}${path}?${queryString}`,
  };
};
